
import ProdHandler from '../prod/abstract-handler';
import Handler from './map-handler';

export default class AbstractHandler extends ProdHandler {

    constructor() {
        super();
    }

}